// extracted by mini-css-extract-plugin
export default {"wrapper":"PricingItem_wrapper__3HAxo","itemWrapper":"PricingItem_itemWrapper__ZtM5R","itemHeading":"PricingItem_itemHeading__mpdjj"};